export default __webpack_public_path__ + "static/media/database.ca52fe53.svg";